"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyStringToNullTransform = emptyStringToNullTransform;
exports.emptyNumberStringToNullTransform = emptyNumberStringToNullTransform;
function emptyStringToNullTransform(value) {
    return value === '' ? null : value;
}
function emptyNumberStringToNullTransform(value) {
    if (value === '' || value == null) {
        return null;
    }
    return typeof value === 'string' ? Number(value) : value;
}
//# sourceMappingURL=utils.js.map